export default function ReturnIcon({ size = 42 }) {
    return (
        <svg width={size} height={size} viewBox={`0 0 42 42`} fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="10" width="4" height="18" fill="url(#paint0_linear_1523_543)" />
            <path d="M28 26V18.9787V8H2M16 30H24" stroke="black" strokeWidth="4" />
            <path d="M2 30H9" stroke="black" strokeWidth="4" />
            <path d="M30 30H38V20C38 16.6863 35.3137 14 32 14V14H30" stroke="url(#paint1_linear_1523_543)" strokeWidth="4" />
            <path d="M16 30C16 32.2091 14.2091 34 12 34C9.79086 34 8 32.2091 8 30C8 27.7909 9.79086 26 12 26C14.2091 26 16 27.7909 16 30Z" stroke="black" strokeWidth="4" />
            <path d="M32 30C32 32.2091 30.2091 34 28 34C25.7909 34 24 32.2091 24 30C24 27.7909 25.7909 26 28 26C30.2091 26 32 27.7909 32 30Z" stroke="black" strokeWidth="4" />
            <defs>
                <linearGradient id="paint0_linear_1523_543" x1="4" y1="15.3182" x2="4" y2="28" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="paint1_linear_1523_543" x1="35.5" y1="15.5" x2="30.5" y2="14.5" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="0.928773" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
}
